import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../../assets/gcm-logo-light.svg';
import logoDark from '../../assets/gcm-logo.svg';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  const [imgError, setImgError] = useState(false);
  // Vérifier si la classe contient 'text-white', ce qui indique que nous sommes sur un fond sombre
  const isWhiteText = className.includes('text-white');
  
  // Utiliser le style pour définir une taille fixe et assurer que le logo s'affiche correctement
  return (
    <Link to="/" className={`flex items-center ${className}`}>
      {imgError ? (
        <div 
          className="h-10 flex items-center justify-center font-bold text-xl"
          style={{ 
            maxWidth: '150px'
          }}
        >
          GCM FRANCE
        </div>
      ) : (
        <div className="relative flex items-center justify-center">
          <img 
            src={isWhiteText ? logoLight : logoDark} 
            alt="GCM FRANCE Logo" 
            className="h-14 w-auto" 
            style={{ 
              objectFit: 'contain',
              maxWidth: '180px',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
              transition: 'transform 0.3s ease',
            }}
            onError={() => setImgError(true)}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          />
        </div>
      )}
    </Link>
  );
};

export default Logo;
